import { getAPIErrorMessage } from 'api';
export function loadEvents(mintime, maxtime, device_id) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: 'LOAD_EVENTS__REQUEST', device_id });
        try {
            const { events, have_more } = await api.events_loc(device_id, mintime, maxtime, 200);
            dispatch({
                type: 'LOAD_EVENTS__OK',
                events,
                have_more,
                device_id,
            });
        }
        catch (error) {
            const err_msg = getAPIErrorMessage(error, 'Не удалось загрузить данные');
            dispatch({
                type: 'LOAD_EVENTS__FAIL',
                error: `Не удалось загрузить список событий: ${err_msg}`,
                device_id,
            });
        }
    };
}
export function loadLastEvents(device_id, limit, excluded_event_types) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: 'LOAD_EVENTS__REQUEST', device_id });
        try {
            const { events } = await api.events_loc(device_id, null, null, limit, excluded_event_types);
            dispatch({
                type: 'LOAD_EVENTS__OK',
                events,
                have_more: false,
                device_id,
            });
        }
        catch (error) {
            const err_msg = getAPIErrorMessage(error, 'Не удалось загрузить данные');
            dispatch({
                type: 'LOAD_EVENTS__FAIL',
                error: `Не удалось загрузить список событий: ${err_msg}`,
                device_id,
            });
        }
    };
}
export function loadMoreEvents(mintime, maxtime, device_id, lastEvent) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: 'LOAD_MORE_EVENTS__REQUEST', device_id });
        try {
            const { events, have_more } = await api.events_loc(device_id, mintime, lastEvent?.time ?? maxtime, 200);
            dispatch({
                type: 'LOAD_MORE_EVENTS__OK',
                events,
                have_more,
                device_id,
            });
        }
        catch ({ json }) {
            dispatch({
                type: 'LOAD_MORE_EVENTS__FAIL',
                error: json?.error_ui ??
                    json?.error ??
                    'Не удалось загрузить список событий',
                device_id,
            });
        }
    };
}
// | SelectDeviceAction;
